module.exports = "https://www.gc-pro.gnp.com.mx/00014decbd72517c764062afbe477fa5.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/trash.png
// module id = 379
// module chunks = 0